import script from "./detail-descriptions.vue?vue&type=script&lang=js"
export * from "./detail-descriptions.vue?vue&type=script&lang=js"

import "./detail-descriptions.vue?vue&type=style&index=0&id=18667b25&lang=scss&scoped=true"

import exportComponent from "/Volumes/kaifa/ApiJavaAdmin/vn-admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18667b25"]])

export default __exports__